interface TrackedEvent {
  name: string;
  passive: boolean;
}

export default class ActivityMonitor extends EventTarget {
  private readonly eventsOnDocument: TrackedEvent[] = [
    { name: "keydown", passive: false },
    { name: "mousedown", passive: true },
    { name: "popstate", passive: false },
    { name: "scroll", passive: true },
    { name: "touchmove", passive: true },
    { name: "touchstart", passive: true },
  ];

  constructor() {
    super();
    this.registerEventListeners();
  }

  announceActivity(): void {
    this.dispatchEvent(
      new CustomEvent("user-activity", {
        bubbles: true,
        composed: true,
      })
    );
  }

  private registerEventListeners() {
    this.eventsOnDocument.forEach((trackedEvent) => {
      document.addEventListener(
        trackedEvent.name,
        this.announceActivity.bind(this),
        {
          passive: trackedEvent.passive,
        }
      );
    });
  }
}
